import { flowTransport, type TFlowTransport } from '@besuites/auth/flow';
import beauthBrowser from '@/lib/beauth/beauth.browser';
import { BEAUTH_FLOW_BASE_URL } from '@/config/beauth.config';

const anonymous = flowTransport({ baseUrl: BEAUTH_FLOW_BASE_URL });

const withSession = flowTransport({ baseUrl: BEAUTH_FLOW_BASE_URL, browser: beauthBrowser });

const pick = (): TFlowTransport => (beauthBrowser.state().access === null ? anonymous : withSession);

const beauthFlowTransport: TFlowTransport = {
    start: (kind, hint, extras) => pick().start(kind, hint, extras),
    advance: (flowId, step, input) => pick().advance(flowId, step, input),
};

export default beauthFlowTransport;
